import Type1 from "./Type1";

export default {Type1};
